export default __webpack_public_path__ + "static/media/pluskim-dergi.9c120993.jpg";